import React from 'react'
import TicketArrowRightSvg from '../assets/icons/TicketArrowRightSvg'

import './IconButtonComp.css'

const IconButtonComp = ({ children, onClick, icon, focus }) => {
  return (
    <button
      onClick={onClick}
      className={'btnContainer'}
      style={{ backgroundColor: focus ? '#205c42' : '#fff' }}
    >
      <div className='btnBody' style={{ color: focus ? '#fff' : '#205c42' }}>
        <div style={{ marginTop: '-3px' }}>{icon}</div>
        {children}
      </div>
      <div>
        <TicketArrowRightSvg width={'1rem'} height={'1rem'} focus={focus} />
      </div>
    </button>
  )
}

export default IconButtonComp
